module.exports = __webpack_public_path__ + "images/tencent_docs/slide-2ca769a20ca8a1652e364768aba2472d.svg";